module.exports = __webpack_public_path__ + "static/media/logout_active.b8294f6b.svg";